import { formatarData, pegarHorario } from "../utils/functions";
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";

const LogsList = ({ logs, setEdit, setEditableLog }) => {

    const handleEdit = (log) => {
        setEdit(true);
        setEditableLog(log);
    }

    const targetNames = {
        user: "Usuário",
        product: "Produto",
        store: "Loja",
        gradablemodel: "Modelo",
        serial: "Serial",
        coupon: "Cupom"
    }

    return (
        <GridComponent dataSource={logs} allowSorting allowPaging pageSettings={{ pageSize: 30 }}>
            <ColumnsDirective>
                <ColumnDirective field='target' headerText="Alvo" width='100' textAlign="Center" valueAccessor={(f, d) => { return targetNames[d?.target] }} />
                <ColumnDirective field='targetId' headerText="ID alvo" width='100' textAlign="Center" />
                <ColumnDirective field='user.email' headerText="Usuário" width='100' textAlign="Center" />
                <ColumnDirective field='createdAt' headerText="Data" width='100' textAlign="Center" valueAccessor={(f, d) => { return formatarData(d?.createdAt) }} />
                <ColumnDirective field='createdAt' headerText="Horário" width='100' textAlign="Center" valueAccessor={(f, d) => { return pegarHorario(d?.createdAt) }} />
                <ColumnDirective width='100' textAlign="Center" template={(d, f) => { return <button onClick={() => handleEdit(d)} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</button> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page]} />
        </GridComponent>
    )
}

export default LogsList;
